import { I18n } from '@calendly/i18n';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseMiniIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const disabledWeekdayIsPhoneCss = "div1do2";
const disabledWeekdayCss = "d19wlyum";
export const DisabledWeekday = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(disabledWeekdayCss, {
    [disabledWeekdayIsPhoneCss]: isPhone
  }, props.className)}>
      {I18n.t('publisher.event_types.availability.unavailable')}
    </Component>;
});
const containerIsTabletUpCss = "c161gfgk";
const containerIsPhoneCss = "cmb9apf";
const containerCss = "c1vmsozv";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsTabletUpCss]: isTabletUp,
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const removeIntervalButtonCss = "r19lasw0";
export const RemoveIntervalButton = forwardRef((props, ref) => <IconButton ref={ref} {...props} className={classNames(removeIntervalButtonCss, props.className)}>
    <CloseMiniIcon />
  </IconButton>);
const timeInputsContainerCss = "t4xd76s";
export const TimeInputsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timeInputsContainerCss, props.className)} />;
});
const inputCss = "ixy4qse";
export const Input = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  return <Component ref={ref} {...restProps} className={classNames(inputCss, props.className)} />;
});

// Export CSS classes for external usage
export { containerCss, disabledWeekdayCss, inputCss, removeIntervalButtonCss, timeInputsContainerCss };

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");